export default __webpack_public_path__ + "static/media/favicon-src.0870eee4.png";